// 남은 시간 표시 — 인증번호 만료 카운트다운처럼 "분:초"만 필요한 자리에 쓴다.
//
// 왜 한 곳인가: 인증 코드를 다루는 화면이 늘 때마다 같은 함수가 복사돼(휴대폰 인증, 회사 클레임)
// 표기가 갈라질 수 있었다. 초 단위 표시는 규칙이 하나여야 화면끼리 어긋나지 않는다.

/**
 * 남은 초를 `분:초`로 (초는 2자리 고정).
 * @example formatCountdown(180) // '3:00'
 * @example formatCountdown(59) // '0:59'
 */
export function formatCountdown(seconds: number): string {
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min}:${sec.toString().padStart(2, '0')}`;
}
